'use client'

import { useEffect } from 'react'

import { reportDatadogError } from '@/plugins/datadog/rum'

type ErrorPageProps = Readonly<{
  error: Error & { digest?: string }
  reset: () => void
}>

export default function ErrorPage({ error, reset }: ErrorPageProps) {
  useEffect(() => {
    reportDatadogError(error, { source: 'next-error-boundary' })
  }, [error])

  return (
    <div className="flex min-h-screen flex-col items-center justify-center gap-4 p-6">
      <h2 className="text-xl font-semibold">Algo deu errado</h2>
      <p className="max-w-md text-center text-sm text-gray-600">
        Ocorreu um erro inesperado. Tente novamente ou volte mais tarde.
      </p>
      <button
        type="button"
        onClick={reset}
        className="rounded bg-blue-600 px-4 py-2 text-sm font-medium text-white hover:bg-blue-700"
      >
        Tentar novamente
      </button>
    </div>
  )
}
